import { MDXProvider } from "@mdx-js/react";
import { graphql, withPrefix } from 'gatsby';
import { MDXRenderer } from "gatsby-plugin-mdx";
import React from 'react';
import ReactGA from 'react-ga';
import Helmet from 'react-helmet';
import { FaChevronDown, FaChevronRight, FaChevronUp } from "react-icons/fa";
import slugify from "slugify";
import '../../styles/basics.css';
import '../../styles/rules.css';
import Footer from '../footer/footer';
import Header from '../header/header';
import Hero from '../hero/hero';
import Links from "../links/links";
import s from './contentSidebar.module.css';
import './layout.css';
import { default as suggestions } from '../header/pages_tags.json';

function camelize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
}

function scrollToTop(scrollDuration) {
  var scrollStep = -window.scrollY / (scrollDuration / 15),
    scrollInterval = setInterval(function () {
      if (window.scrollY !== 0) {
        window.scrollBy(0, scrollStep);
      }
      else clearInterval(scrollInterval);
    }, 15);
}



function PostPageTemplate({ data: { mdx } }) {


  const [tags, setTags] = React.useState([]);

  React.useEffect(() => {    
      let pathName = window.location.pathname;
      setTags(suggestions.pages.filter((page) => (pathName === page.URL || (pathName + '/') === page.URL || pathName === page.URL + '/')));
    
  }, []);

  return (
    <>
      <Helmet
        meta={[
          { name: 'title', content: !tags[0] ? '' : tags[0].Titulo },
          { name: 'description', content: !tags[0] ? '' : tags[0].Descripcion }
        ]}
      >
        <html lang="es-PE" />
      </Helmet>
      <Header />
      <main>
        <article>

          <Hero
            title={mdx.frontmatter.titulo}
            image={mdx.frontmatter.imageBanner}
          />
          <div className={`container ${s.content}`}>
            {
               mdx.frontmatter.secciones.length !== 0 ?
               <aside className={`mt-5 ${s.sidebar}`}>
               <ol className={`${s.sidebar_list}`}>
                 {mdx.frontmatter.secciones.map((item, index) =>
                   <li key={index} className={`mb-4 ph-3 flex items-center justify-between ${s.asideItem}`}>
                     <a className={s.asideLinkScroll} onClick={() => ReactGA.event({ category: camelize(mdx.frontmatter.titulo), action: 'clic', label: camelize(item) })} href={`#${slugify(item, { lower: true })}`}>{item}</a>
                     <div className={`ml-2 ${s.asideChevron}`}>
                       <FaChevronRight size='0.8em' className='dn db@md' />
                       <FaChevronDown size='0.8em' className='dn@md db' />
                     </div>
                   </li>
                 )}
               </ol>
             </aside>
              : null
            }
            <div className={`pl-5@md ${s.mdxTheme}`}>
              <MDXProvider
                components={{
                  // configuration component, not need to generate a warning
                  // eslint-disable-next-line
                  h1: props => <h2 {...props} id={slugify(`${{ ...props }.children}`, { lower: true })} className={`f-3 f-5@md fw--1 mb-4 c-skyblue-0 ${s.anchor}`} />,
                  // configuration component, not need to generate a warning
                  // eslint-disable-next-line
                  h2: props => <h2 {...props} className='f-4 f-5@md fw--1 mb-4 c-skyblue-0' />,
                  // configuration component, not need to generate a warning
                  // eslint-disable-next-line
                  h3: props => <h3 {...props} className={`f-1 f-2@md fw-0 c-gray--1 mb-3 mt-4 ${props.className}`} />,
                  // configuration component, not need to generate a warning
                  // eslint-disable-next-line
                  h4: props => <h4 {...props} className='f-1 f-2@md fw-0 c-gray--2 mb-3 mt-4' />,
                  // configuration component, not need to generate a warning
                  // eslint-disable-next-line
                  h5: props => <h5 {...props} className='f-1 fw-0 mb-2 mt-4' />,
                  // configuration component, not need to generate a warning
                  // eslint-disable-next-line
                  h6: props => <h6 {...props} className='f-1 fw-0 mb-2 mt-4' />,
                  p: props => <p {...props} className={`${props.className || ''} mv-3`} />,
                  ul: props => <ul {...props} className={`pl-2 bullets ${props.className}`} />,
                  img: props => <div style={{ overflow: 'auto' }}><img {...props} alt='' src={withPrefix(props.src)} style={{ maxWidth: 'none', ...props.style }} /></div>,
                  ol: props => <ol {...props} className={`pl-2 bullets`} />,
                  section: props => <section {...props} />,
                  table: props => <div className='table'><table {...props} /></div>,
                  a: props => <Links to={`${props.href}`}>{props.children}</Links>,
                  small: props => <small className={props.className}>{props.children}</small>
                }}
              >
                <MDXRenderer>{mdx.body}</MDXRenderer>
              </MDXProvider>
            </div>
          </div>
        </article>
        <button onClick={() => scrollToTop(500)} className={s.topButton} id='scrollButton'>
          <FaChevronUp />
        </button>
      </main>
      <Footer />
    </>
  );
}
export default PostPageTemplate;
export const pageQuery = graphql`
  query($id: String!) {
    mdx(id: { eq: $id }) {
      id
      body
      frontmatter {
        titulo
        secciones
        imageBanner
      }
    }
  }
`;
